"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFindRootGroups = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useFindRootGroups() {
    const { data, isLoading, error, get } = (0, core_ui_1.useApiGet)('groups/roots');
    return { groups: data, isLoading, error, findGroups: get };
}
exports.useFindRootGroups = useFindRootGroups;
//# sourceMappingURL=useFindRootGroups.js.map